import { inputResult } from "../Submit/SaveAnswer";


export function transformOrToResult(input:JQuery, results:inputResult, points:number, possible:number){

    const options = input.find(".order-option");

    // Maybe disable dragging functionality

    options.each((ind, obj) => {

        const item = $(obj)

        

        if (results.answer[ind] == results.correct[ind]){
            item.css('border', '1px solid green');
        } else {
            item.css('border', '1px solid red');
        }
    })

}